import { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import InsideLayout from "../layouts/InsideLayout";
import { fetchProfile } from "../redux/actions/userActionCreators";

function PrivateRoute({ component: Component, allowedRoles, ...rest }) {
  const dispatch = useDispatch();
  const { isAuth, profile } = useSelector((state) => state.user);
  const storedUser = localStorage.getItem("user");
  let currentAccountType = null;

  try {
    const parsedUser = storedUser ? JSON.parse(storedUser) : {};
    currentAccountType = parsedUser?.account_type || null;
  } catch (err) {
    currentAccountType = null;
  }

  const requiresRoleCheck = Array.isArray(allowedRoles) && allowedRoles.length > 0;
  const effectiveAccountType = profile?.account_type || currentAccountType;
  const unauthorizedRedirect =
    effectiveAccountType === "enterprise" ? "/enterprise" : "/dashboard";

  useEffect(() => {
    if (isAuth && !profile) {
      dispatch(fetchProfile());
    }
  }, [dispatch, isAuth, profile]);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuth ? (
          <Redirect to="/login" />
        ) : requiresRoleCheck ? (
          !profile?.role ? null : !allowedRoles.includes(profile.role) ? (
            <Redirect to={unauthorizedRedirect} />
          ) : (
            <InsideLayout>
              <Component {...props} />
            </InsideLayout>
          )
        ) : (
          <InsideLayout>
            <Component {...props} />
          </InsideLayout>
        )
      }
    />
  );
}

export default PrivateRoute;
